import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Mail } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/forgot-password`, { email, base_url: window.location.origin });
      setSubmitted(true);
    } catch (error) {
      console.error('Forgot password error:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
      <div className="w-full max-w-md p-8 bg-white border-2 border-black" data-testid="forgot-password-form">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'var(--heading-font)' }}>
            RESET PASSWORD
          </h1>
          <p className="text-zinc-600">Enter your admin email to receive a reset link</p>
        </div>

        {submitted ? (
          <div className="text-center space-y-4" data-testid="forgot-password-success">
            <div className="bg-green-50 border border-green-200 p-4 text-sm text-green-800">
              If an account exists for that email, a password reset link has been sent. Please check your inbox (the link expires in 1 hour).
            </div>
            <Link to="/admin/login" className="inline-flex items-center gap-2 text-sm font-medium text-zinc-700 hover:text-black">
              <ArrowLeft size={16} /> Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email">Admin Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-email-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[var(--accent)] text-black hover:bg-[var(--accent-hover)] rounded-full px-8 py-4 text-lg font-bold transition-transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="send-reset-link-btn"
            >
              <Mail size={20} />
              {loading ? 'SENDING...' : 'SEND RESET LINK'}
            </button>
          </form>
        )}

        <div className="mt-8 pt-6 border-t border-zinc-200 text-center">
          <Link to="/admin/login" className="inline-flex items-center gap-2 text-sm font-medium text-zinc-600 hover:text-black transition-colors" data-testid="back-to-login-link">
            <ArrowLeft size={16} /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
